import React, { useCallback, useContext, useState } from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../../store';
import { IAdminTeamResult } from '../../../../../../../../store/admin/teamResults/store';
import { ScoreType } from '../../../../../../../../store/admin/eventFormats/store';
import { IHoleScore, IScore } from '../../../../../../../../store/player/scores/store';

import { useBoolean } from '../../../../../../../common/Hooks/useBoolean.hook';
import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { IObjectById } from '../../../../../../../../contrib/Utils/getObjectByIdFromArray';
import { displayPosition } from '../../../../../../../../contrib/Utils/displayPosition';
import { displayScore } from '../../../../../../../../contrib/Utils/displayScore';
import RoundScoreSummary from '../../../../../../../../components/RoundScoreSummary/RoundScoreSummary';
import ResultsFooter from '../../../../../RoundResults/ResultsFooter';
import { useSummaryStateLogic } from '../../../../../../Common/Hooks/useSummaryStateLogic';
import { ITeamHoleScore } from '../../../../../../../common/Hooks/useLeaderboardsResults';

interface IProps {
  result: IAdminTeamResult;
  clubId: number;
  eventId: number;
  roundId: number;
  selectedScoreType?: ScoreType;
  showNoPosition?: boolean;
  formattedTeamsHoleResults?: IObjectById<ITeamHoleScore>;
}

export const TeamStrokeTableRow = (props: IProps) => {
  const {
    result,
    selectedScoreType,
    roundId: propsRoundId,
    clubId,
    eventId,
    formattedTeamsHoleResults
  } = props;
  const { selectedCombination, selectedTeamFormat } = useAssignResultsState();

  const {
    actions: {
      roundScores: { save: saveRoundScores },
      adminEventRounds: { updateGames, get: getAdminEventRound },
      roundScores: { get: getRoundScores }
    },
    adminEvents: events,
    adminEventRounds: rounds,
    roundScores
  } = useContext(GlobalContext);

  const [expandedRow, , toggleExpandedRow] = useBoolean(false);
  const [signed, setSigned] = useState(false);
  const event = events[Number(eventId)];

  const [roundId, setRoundId] = useState(propsRoundId);

  const updateRound = useCallback(async (newRoundId: string) => {
    await getAdminEventRound(Number(clubId), Number(eventId), Number(newRoundId));
    await getRoundScores(clubId, eventId, newRoundId);

    setRoundId(Number(newRoundId));
  }, []);

  const {
    onCancelEdit,
    onChangeRound,
    onSave,
    onToggleEdit,
    editMode,
    penalties,
    setPenalties,
    player,
    setNewScores
  } = useSummaryStateLogic({
    clubId,
    eventId,
    playerId: result.teamId,
    roundId,
    roundScores,
    rounds,
    saveRoundScores,
    updateGames,
    updateRound
  });

  const teamGameId = result.teamGameId;
  const scores: IHoleScore[] =
    formattedTeamsHoleResults && formattedTeamsHoleResults[teamGameId]
      ? formattedTeamsHoleResults[teamGameId].scores
      : [];

  const selectedScores: IScore = {
    enrollment: 0,
    grossScore: 60,
    group: 0,
    handicap: 0,
    id: 0,
    netScore: 0,
    qualified: true,
    round: 0,
    scores,
    seat: 0,
    status: ''
  };

  return selectedCombination ? (
    <>
      <TableRow onClick={toggleExpandedRow} className="results-table-table-body-row">
        <TableCell className="index">
          {displayPosition(result, selectedTeamFormat, selectedScoreType)}
        </TableCell>
        <TableCell className="playerName">{result.teamName}</TableCell>
        <TableCell className="result">
          {displayScore(result, selectedTeamFormat, selectedScoreType)}
        </TableCell>

        <TableCell>{result.through}</TableCell>
      </TableRow>
      <TableRow className="expandable-row" style={{ height: 0 }}>
        <TableCell
          className="inner-cell"
          colSpan={4}
          classes={{ root: 'leaderboard-row-event-summary' }}
        >
          <Collapse
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={expandedRow}
            timeout="auto"
            unmountOnExit={true}
          >
            <RoundScoreSummary
              editing={editMode}
              footer={ResultsFooter(
                onToggleEdit,
                onCancelEdit,
                onSave,
                editMode,
                event ? event.rounds : [],
                onChangeRound,
                roundId
              )}
              hideHandicapsRow={true}
              hideHeader={true}
              item={player as any}
              onChange={setNewScores}
              onChangePenalties={setPenalties}
              onChangeSignature={setSigned}
              penalties={penalties}
              playerScores={selectedScores}
              signed={signed}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  ) : (
    <></>
  );
};
